import { ICellRendererParams } from "ag-grid-enterprise";
import { FC, ReactNode, useCallback, useSyncExternalStore } from "react";
import Highlighter from "react-highlight-words";
import CopyToClipboard from "../../Common/CopyToClipboard/CopyToClipboard";

interface GridHighlightedValueProps extends ICellRendererParams {
    columnKey: string;
    enableCopyToClipboard?: boolean;
}

const GridHighlightedValue: FC<GridHighlightedValueProps> = ({ api, value, columnKey, enableCopyToClipboard = false }) => {
    // A client-side filter does not re-render the rows that stay visible, so the cell listens for
    // filter changes itself; otherwise it keeps highlighting the text it was first rendered with.
    const subscribe = useCallback(
        (onChange: () => void) => {
            api.addEventListener("filterChanged", onChange);
            return () => {
                if (!api.isDestroyed()) api.removeEventListener("filterChanged", onChange);
            };
        },
        [api],
    );
    const searchText = useSyncExternalStore(subscribe, () => {
        const filter = api.getColumnFilterModel<any>(columnKey);
        return filter?.type === "contains" ? String(filter.filter ?? "") : "";
    });

    const renderedValue: ReactNode = searchText ? <Highlighter searchWords={[searchText]} autoEscape textToHighlight={value.toString()} /> : value;

    return enableCopyToClipboard ? <CopyToClipboard>{renderedValue}</CopyToClipboard> : renderedValue;
};

export default GridHighlightedValue;
